import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = ({ isToday }: { isToday: boolean }) =>
  makeStyles((theme: Theme) => ({
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: theme.spacing(1.25),
      backgroundColor: isToday ? "#000" : "#f9f9f9",
      fontFamily: "SFProText-Bold",
    },
    day: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      fontSize: "13px",
      color: "#a0a0a0",
    },
    dayLabel: {
      color: "#b1b1b1",
      textTransform: "uppercase",
    },
    icons: {
      fontSize: "20px",
      marginLeft: theme.spacing(0.625),
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    date: {
      position: "absolute",
      opacity: 0,
      zIndex: -100,
    },
    span: {
      marginLeft: theme.spacing(0.625),
    },
    iconWithTransition: {
      transition: "1s ease",
      "&:hover": {
        cursor: "pointer",
      },
    },
    number: {
      color: "black",
      fontWeight: "bold",
    },
    icon: {
      fontSize: "20px",
      color: "#b8b8b8",
      transition: "1s ease",
      "&:hover": {
        cursor: "pointer",
        color: "black",
      },
    },
    popoverWorkout: {
      "& div[class~='ant-popover-inner-content']": {
        borderRadius: theme.spacing(0.875),
        padding: "0 !important",
        overflow: "hidden",
      },
    },
    button: {
      color: "#a2a2a2",
      marginLeft: theme.spacing(1.25),
      "& span": {
        fontSize: "14px",
        textTransform: "uppercase",
      },
    },
  }));

export default useStyles;
